// extracted by mini-css-extract-plugin
export default {"Dimension":"Dimension_Dimension__WLd7c","dimensionInput":"Dimension_dimensionInput__xLUMS","unit":"Dimension_unit__jUHRB"};